import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  MenuItem,
  Select
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import './UserDetails.scss'
import { getCountryList } from 'services/CustomerService';

const UserDetails = ({ onSubmit, initialData }) => {
  const {
    control,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: initialData || {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      countryCode: "+91",
      email: ''
    },
    mode: 'onChange'
  });

  const watchedFields = watch();
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      const response = await getCountryList();
      if (response && response.data) {
        setCountryList(response.data?.sort((a, b) => a.name.localeCompare(b.name))?.map((data) => {return {value: `+${data?.dialCode}`, label: `${data?.code} +${data?.dialCode}`}}));
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    onSubmit(watchedFields);
  }, [watchedFields]);

  return (
    <Box className="user-details-container">
      <Typography variant="h5" className="mb-6 text-[20px] font-semibold text-[#0f538d]">
        Enter Traveller Details
      </Typography>

      {/* Input Fields */}
      <Grid container spacing={3} pt={3}>
        {/* Name */}
        <Grid item xs={12} md={3}>
          <Box>
            <Typography 
              component="label" 
              className="block text-sm font-medium text-gray-700 pb-2"
            >
              First Name<span className="text-red-500">*</span>
            </Typography>
            <Controller
              name="firstName"
              control={control}
              rules={{
                required: 'FirstName is required',
                minLength: {
                  value: 2,
                  message: 'Name must be at least 2 characters'
                }
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  placeholder="Enter FirstName"
                  variant="outlined"
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                  className="bg-white"
                />
              )}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Box>
            <Typography 
              component="label" 
              className="block text-sm font-medium text-gray-700 pb-2"
            >
              Last Name
            </Typography>
            <Controller
              name="lastName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  placeholder="Enter LastName"
                  variant="outlined"
                  className="bg-white"
                />
              )}
            />
          </Box>
        </Grid>

        {/* Phone Number */}
        <Grid item xs={12} md={3}>
          <Box>
            <Typography 
              component="label" 
              className="block text-sm font-medium text-gray-700 pb-2"
            >
              Phone Number<span className="text-red-500">*</span>
            </Typography>
            <Controller
              name="phoneNumber"
              control={control}
              rules={{
                required: 'Phone number is required',
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: 'Please enter a valid 10-digit phone number'
                }
              }}
              render={({ field }) => (
                <Box className="flex gap-2" sx={{ alignItems: 'flex-start' }}>
                  <Select
                    value={watchedFields.countryCode}
                    onChange={(e) => setValue('countryCode', e.target.value)}
                    variant="outlined"
                    className="w-24 bg-white country-code-select"
                    sx={{ '& .MuiSelect-select': { py: 0.5 }, height: 48 }}
                  >
                    {countryList?.map((country) => (
                      <MenuItem key={country.value} value={country.value}>
                        {country.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    {...field}
                    fullWidth
                    placeholder="Enter Phone Number"
                    variant="outlined"
                    error={!!errors.phoneNumber}
                    helperText={errors.phoneNumber?.message}
                    className="bg-white flex-1"
                  />
                </Box>
              )}
            />
          </Box>
        </Grid>

        {/* Email */}
        <Grid item xs={12} md={3}>
          <Box>
            <Typography 
              component="label" 
              className="block text-sm font-medium text-gray-700 pb-2"
            >
              Email
            </Typography>
            <Controller
              name="email"
              control={control}
              rules={{
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Please enter a valid email address'
                }
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  placeholder="Enter Email"
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  className="bg-white"
                />
              )}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserDetails;

